import * as React from "react";
const SvgMenu = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: 24, viewBox: "0 -960 960 960", width: 24, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z" }));
export default SvgMenu;
